import { NewAccountInfoOutputFromWireFormat } from '@core/types/api/AccountInfoOutput/AccountInfoOutput';
import { NewActivityFromWireFormat } from '@core/types/api/Activity/Activity';
import { NewActivitySummaryFromWireFormat } from '@core/types/api/ActivitySummary/ActivitySummary';
import { NewActualsCustomerPerformanceSummaryFromWireFormat } from '@core/types/api/ActualsCustomerPerformanceSummary/ActualsCustomerPerformanceSummary';
import { NewActualsMetricsFromWireFormat } from '@core/types/api/ActualsMetrics/ActualsMetrics';
import { NewActualsPlantPerformanceSummaryFromWireFormat } from '@core/types/api/ActualsPlantPerformanceSummary/ActualsPlantPerformanceSummary';
import { NewActualsProjectMonthlyBreakdownSummaryFromWireFormat } from '@core/types/api/ActualsProjectMonthlyBreakdownSummary/ActualsProjectMonthlyBreakdownSummary';
import { NewActualsProjectPerformanceSummaryFromWireFormat } from '@core/types/api/ActualsProjectPerformanceSummary/ActualsProjectPerformanceSummary';
import { NewActualsProjectProductBreakdownSummaryFromWireFormat } from '@core/types/api/ActualsProjectProductBreakdownSummary/ActualsProjectProductBreakdownSummary';
import { NewAddressFromWireFormat } from '@core/types/api/Address/Address';
import { NewAdjustedPricing } from '@core/types/api/AdjustedPricing/AdjustedPricing';
import { NewAsyncJobDetailFromWireFormat } from '@core/types/api/AsyncJobDetail/AsyncJobDetail';
import { NewAsyncJobSummaryFromWireFormat } from '@core/types/api/AsyncJobSummary/AsyncJobSummary';
import { NewAuthorizationOutputFromWireFormat } from '@core/types/api/AuthorizationOutput/AuthorizationOutput';
import { NewAuthorizationTokenOutputFromWireFormat } from '@core/types/api/AuthorizationTokenOutput/AuthorizationTokenOutput';
import { NewAutocompletePredictionFromWireFormat } from '@core/types/api/AutocompletePrediction/AutocompletePrediction';
import { NewCheckQuotePoliciesResultsFromWireFormat } from '@core/types/api/CheckQuotePoliciesResults/CheckQuotePoliciesResults';
import { NewCompanyFromWireFormat } from '@core/types/api/Company/Company';
import { NewCompanyCategoryAggFromWireFormat } from '@core/types/api/CompanyCategoryAgg/CompanyCategoryAgg';
import { NewCompanySummary } from '@core/types/api/CompanySummary/CompanySummary';
import { NewCompetitorFromWireFormat } from '@core/types/api/Competitor/Competitor';
import { NewCompetitorPlantFromWireFormat } from '@core/types/api/CompetitorPlant/CompetitorPlant';
import { NewCompetitorProductSummary } from '@core/types/api/CompetitorProductSummary/CompetitorProductSummary';
import { NewCompetitorSummary } from '@core/types/api/CompetitorSummary/CompetitorSummary';
import { NewContactFromWireFormat } from '@core/types/api/Contact/Contact';
import { NewContactSummaryFromWireFormat } from '@core/types/api/ContactSummary/ContactSummary';
import { NewCustomFieldDefinitionFromWireFormat } from '@core/types/api/CustomFieldDefinition/CustomFieldDefinition';
import { NewDispatchActualsSyncInfoFromWireFormat } from '@core/types/api/DispatchActualsSyncInfo/DispatchActualsSyncInfo';
import { NewDispatchCustomerFromWireFormat } from '@core/types/api/DispatchCustomer/DispatchCustomer';
import { NewDispatchCustomerAggFromWireFormat } from '@core/types/api/DispatchCustomerAgg/DispatchCustomerAgg';
import { NewDispatchCustomerMatchInfoFromWireFormat } from '@core/types/api/DispatchCustomerMatchInfo/DispatchCustomerMatchInfo';
import { NewDispatchCustomerSummaryFromWireFormat } from '@core/types/api/DispatchCustomerSummary/DispatchCustomerSummary';
import { NewDispatchCustomerToCompanyPossibleMatchesFromWireFormat } from '@core/types/api/DispatchCustomerToCompanyPossibleMatches/DispatchCustomerToCompanyPossibleMatches';
import { NewDistanceResultFromWireFormat } from '@core/types/api/DistanceResult/DistanceResult';
import { NewDivisionFromWireFormat } from '@core/types/api/Division/Division';
import { NewEscalationWindowStatsFromWireFormat } from '@core/types/api/EscalationWindowStats/EscalationWindowStats';
import { NewFileFromWireFormat } from '@core/types/api/File/File';
import { NewFixedPricing } from '@core/types/api/FixedPricing/FixedPricing';
import { NewFixedPricingByCompany } from '@core/types/api/FixedPricingByCompany/FixedPricingByCompany';
import { NewForecastFromWireFormat } from '@core/types/api/Forecast/Forecast';
import { NewForecastAggFromWireFormat } from '@core/types/api/ForecastAgg/ForecastAgg';
import { NewGeneratedPDFFromWireFormat } from '@core/types/api/GeneratedPDF/GeneratedPDF';
import { NewIgnoredDispatchCustomerFromWireFormat } from '@core/types/api/IgnoredDispatchCustomer/IgnoredDispatchCustomer';
import { NewImportedDiscountFromWireFormat } from '@core/types/api/ImportedDiscount/ImportedDiscount';
import { NewImportedDiscountSummary } from '@core/types/api/ImportedDiscountSummary/ImportedDiscountSummary';
import { NewImportedPricing } from '@core/types/api/ImportedPricing/ImportedPricing';
import { NewIntegrationFromWireFormat } from '@core/types/api/Integration/Integration';
import { NewLinkDispatchCustomerToCompanyFromWireFormat } from '@core/types/api/LinkDispatchCustomerToCompany/LinkDispatchCustomerToCompany';
import { NewLinkedDispatchCustomerFromWireFormat } from '@core/types/api/LinkedDispatchCustomer/LinkedDispatchCustomer';
import { NewLocationResultFromWireFormat } from '@core/types/api/LocationResult/LocationResult';
import { NewMarketFromWireFormat } from '@core/types/api/Market/Market';
import { NewMarketSummaryFromWireFormat } from '@core/types/api/MarketSummary/MarketSummary';
import { NewMaterialFromWireFormat } from '@core/types/api/Material/Material';
import { NewMaterialSummary } from '@core/types/api/MaterialSummary/MaterialSummary';
import { NewMaterialTypeAggFromWireFormat } from '@core/types/api/MaterialTypeAgg/MaterialTypeAgg';
import { NewMixFromWireFormat } from '@core/types/api/Mix/Mix';
import { NewMixMaterialFromWireFormat } from '@core/types/api/MixMaterial/MixMaterial';
import { NewMixSummary } from '@core/types/api/MixSummary/MixSummary';
import { NewNotificationMessageFromWireFormat } from '@core/types/api/NotificationMessage/NotificationMessage';
import { NewNotificationSettingsFromWireFormat } from '@core/types/api/NotificationSettings/NotificationSettings';
import { NewNotificationStatsFromWireFormat } from '@core/types/api/NotificationStats/NotificationStats';
import { NewPdfTemplateFromWireFormat } from '@core/types/api/PdfTemplate/PdfTemplate';
import { NewPlanningBudgetApprovalFromWireFormat } from '@core/types/api/PlanningBudgetApproval/PlanningBudgetApproval';
import { NewPlanningBudgetEntryFromWireFormat } from '@core/types/api/PlanningBudgetEntry/PlanningBudgetEntry';
import { NewPlanningForecastEntryFromWireFormat } from '@core/types/api/PlanningForecastEntry/PlanningForecastEntry';
import { NewPlanningNodeFromWireFormat } from '@core/types/api/PlanningNode/PlanningNode';
import { NewPlanningProductFromWireFormat } from '@core/types/api/PlanningProduct/PlanningProduct';
import { NewPlanningReportingGroupFromWireFormat } from '@core/types/api/PlanningReportingGroup/PlanningReportingGroup';
import { NewPlanningRollupCellFromWireFormat } from '@core/types/api/PlanningRollupCell/PlanningRollupCell';
import { NewPlanningYearFromWireFormat } from '@core/types/api/PlanningYear/PlanningYear';
import { NewPlantFromWireFormat } from '@core/types/api/Plant/Plant';
import { NewPlantSummaryFromWireFormat } from '@core/types/api/PlantSummary/PlantSummary';
import { NewPriceEscalationQuoteSummary } from '@core/types/api/PriceEscalationQuoteSummary/PriceEscalationQuoteSummary';
import { NewProductFromWireFormat } from '@core/types/api/Product/Product';
import { NewProductCategoryAggFromWireFormat } from '@core/types/api/ProductCategoryAgg/ProductCategoryAgg';
import { NewProductSummary } from '@core/types/api/ProductSummary/ProductSummary';
import { NewProjectFromWireFormat } from '@core/types/api/Project/Project';
import { NewProjectCompanyFromWireFormat } from '@core/types/api/ProjectCompany/ProjectCompany';
import { NewProjectConfigFromWireFormat } from '@core/types/api/ProjectConfig/ProjectConfig';
import { NewProjectConfigProductFromWireFormat } from '@core/types/api/ProjectConfigProduct/ProjectConfigProduct';
import { NewProjectConfigSummary } from '@core/types/api/ProjectConfigSummary/ProjectConfigSummary';
import { NewProjectForecastSummaryFromWireFormat } from '@core/types/api/ProjectForecastSummary/ProjectForecastSummary';
import { NewProjectLossReasonFromWireFormat } from '@core/types/api/ProjectLossReason/ProjectLossReason';
import { NewProjectMapPinFromWireFormat } from '@core/types/api/ProjectMapPin/ProjectMapPin';
import { NewProjectProductFromWireFormat } from '@core/types/api/ProjectProduct/ProjectProduct';
import { NewProjectStatusFromWireFormat } from '@core/types/api/ProjectStatus/ProjectStatus';
import { NewProjectStatusAggFromWireFormat } from '@core/types/api/ProjectStatusAgg/ProjectStatusAgg';
import { NewProjectSummary } from '@core/types/api/ProjectSummary/ProjectSummary';
import { NewPushNotificationDeviceFromWireFormat } from '@core/types/api/PushNotificationDevice/PushNotificationDevice';
import { NewQuoteFromWireFormat } from '@core/types/api/Quote/Quote';
import { NewQuoteArchiveResultFromWireFormat } from '@core/types/api/QuoteArchiveResult/QuoteArchiveResult';
import { NewQuoteBulkPriceUpdatePreviewStatsFromWireFormat } from '@core/types/api/QuoteBulkPriceUpdatePreviewStats/QuoteBulkPriceUpdatePreviewStats';
import { NewQuoteConfigFromWireFormat } from '@core/types/api/QuoteConfig/QuoteConfig';
import { NewQuoteConfigSummaryFromWireFormat } from '@core/types/api/QuoteConfigSummary/QuoteConfigSummary';
import { NewQuoteLossReasonFromWireFormat } from '@core/types/api/QuoteLossReason/QuoteLossReason';
import { NewQuotePolicyFromWireFormat } from '@core/types/api/QuotePolicy/QuotePolicy';
import { NewQuotePolicyViolationFromWireFormat } from '@core/types/api/QuotePolicyViolation/QuotePolicyViolation';
import { NewQuoteProductFromWireFormat } from '@core/types/api/QuoteProduct/QuoteProduct';
import { NewQuoteProductSummary } from '@core/types/api/QuoteProductSummary/QuoteProductSummary';
import { NewQuoteStatusFromWireFormat } from '@core/types/api/QuoteStatus/QuoteStatus';
import { NewQuoteStatusAggFromWireFormat } from '@core/types/api/QuoteStatusAgg/QuoteStatusAgg';
import { NewQuoteSummary } from '@core/types/api/QuoteSummary/QuoteSummary';
import { NewQuoteSuspendedOrderFromWireFormat } from '@core/types/api/QuoteSuspendedOrder/QuoteSuspendedOrder';
import { NewReferralInviteRequest } from '@core/types/api/ReferralInviteRequest/ReferralInviteRequest';
import { NewReminderSystemSettingFromWireFormat } from '@core/types/api/ReminderSystemSetting/ReminderSystemSetting';
import { NewReminderSystemSettingSummaryFromWireFormat } from '@core/types/api/ReminderSystemSettingSummary/ReminderSystemSettingSummary';
import { NewReminderUserSettingFromWireFormat } from '@core/types/api/ReminderUserSetting/ReminderUserSetting';
import { NewReminderUserSettingSummaryFromWireFormat } from '@core/types/api/ReminderUserSettingSummary/ReminderUserSettingSummary';
import { NewRevokeTokenOutputFromWireFormat } from '@core/types/api/RevokeTokenOutput/RevokeTokenOutput';
import { NewRoleFromWireFormat } from '@core/types/api/Role/Role';
import { NewSegmentFromWireFormat } from '@core/types/api/Segment/Segment';
import { NewSendMessageOutputFromWireFormat } from '@core/types/api/SendMessageOutput/SendMessageOutput';
import { NewSignedDashboardFromWireFormat } from '@core/types/api/SignedDashboard/SignedDashboard';
import { NewTaxCodeFromWireFormat } from '@core/types/api/TaxCode/TaxCode';
import { NewTenantFromWireFormat } from '@core/types/api/Tenant/Tenant';
import { NewTenantMarginOverviewFromWireFormat } from '@core/types/api/TenantMarginOverview/TenantMarginOverview';
import { NewTierPricingSettings } from '@core/types/api/TierPricingSettings/TierPricingSettings';
import { NewTruckingTypeFromWireFormat } from '@core/types/api/TruckingType/TruckingType';
import { NewTruckingTypeSummaryFromWireFormat } from '@core/types/api/TruckingTypeSummary/TruckingTypeSummary';
import { NewUnlinkedDispatchCustomerFromWireFormat } from '@core/types/api/UnlinkedDispatchCustomer/UnlinkedDispatchCustomer';
import { NewUnmergedDispatchCustomerFromWireFormat } from '@core/types/api/UnmergedDispatchCustomer/UnmergedDispatchCustomer';
import { NewUpdateTenantSettingsRequest } from '@core/types/api/UpdateTenantSettingsRequest/UpdateTenantSettingsRequest';
import { NewUpdateVarianceThresholdSettingsRequest } from '@core/types/api/UpdateVarianceThresholdSettingsRequest/UpdateVarianceThresholdSettingsRequest';
import { NewUserFromWireFormat } from '@core/types/api/User/User';
import { NewUserEmailDefault } from '@core/types/api/UserEmailDefault/UserEmailDefault';
import { NewUserEmailSignatureFromWireFormat } from '@core/types/api/UserEmailSignature/UserEmailSignature';
import { NewUserInfoFromWireFormat } from '@core/types/api/UserInfo/UserInfo';
import { NewUserSettingFromWireFormat } from '@core/types/api/UserSetting/UserSetting';
import { NewUserSummaryFromWireFormat } from '@core/types/api/UserSummary/UserSummary';
import { NewVarianceThresholdSettingsFromWireFormat } from '@core/types/api/VarianceThresholdSettings/VarianceThresholdSettings';
import { List } from '@core/types/list';
import type { GlobalSearchResponse } from '@core/types/search';
import { hasValue } from '@core/utils/equality';

import type { MutationRouteBarrelKeys, QueryRouteBarrelKeys } from './routes';

export type QueryBarrelVals = {
  // split URL path to allow for substituting path parameters
  urlSplits: string[];
  new: (args: any) => any;
  headers?: { [key: string]: string };
};

export type MutationBarrelVals = {
  method: 'POST' | 'PUT' | 'DELETE';
  urlSplits: string[];
  invalidations: QueryRouteBarrelKeys[];
  new: (args: any) => any;
};

export const QueryRouteBarrelVals: Record<QueryRouteBarrelKeys, QueryBarrelVals> = {
  'GET activities': {
    urlSplits: ['/slab/activities'],
    new: (args) => new List(NewActivityFromWireFormat, args),
  },
  'GET activities by company ID': {
    urlSplits: ['/slab/companies/', 'id', '/activities'],
    new: (args) => (args ?? []).map((a: any) => NewActivityFromWireFormat(a)),
  },
  'GET activities by contact ID': {
    urlSplits: ['/slab/contacts/', 'id', '/activities'],
    new: (args) => (args ?? []).map((a: any) => NewActivityFromWireFormat(a)),
  },
  'GET activities by project ID': {
    urlSplits: ['/slab/projects/', 'id', '/activities'],
    new: (args) => (args ?? []).map((a: any) => NewActivityFromWireFormat(a)),
  },
  'GET activities by user ID': {
    urlSplits: ['/slab/users/', 'id', '/activities'],
    new: (args) => (args ?? []).map((a: any) => NewActivityFromWireFormat(a)),
  },
  'GET activities summaries': {
    urlSplits: ['/slab/activities/summaries'],
    new: (args) => new List(NewActivitySummaryFromWireFormat, args),
  },
  'GET activity by ID': {
    urlSplits: ['/slab/activities/', 'id'],
    new: (args) => NewActivityFromWireFormat(args),
  },
  'GET actuals metrics': {
    urlSplits: ['/slab/actuals/metrics'],
    new: (args) => NewActualsMetricsFromWireFormat(args),
  },
  'GET actuals project monthly breakdown summary': {
    urlSplits: ['/slab/actuals/projects-performance/', 'id', '/monthly-breakdown'],
    new: (args) => new List(NewActualsProjectMonthlyBreakdownSummaryFromWireFormat, args),
  },
  'GET actuals project product breakdown summary': {
    urlSplits: ['/slab/actuals/projects-performance/', 'id', '/product-breakdown'],
    new: (args) => new List(NewActualsProjectProductBreakdownSummaryFromWireFormat, args),
  },
  'GET actuals projects performance summary': {
    urlSplits: ['/slab/actuals/projects-performance'],
    new: (args) => new List(NewActualsProjectPerformanceSummaryFromWireFormat, args),
  },
  'GET actuals projects performance typeahead': {
    urlSplits: ['/slab/actuals/projects-performance/typeahead'],
    new: (args) => args ?? [],
  },
  'GET actuals sync info': {
    urlSplits: ['/slab/actuals/sync-status'],
    new: (args) => NewDispatchActualsSyncInfoFromWireFormat(args),
  },
  'GET ai session': {
    urlSplits: ['/slab/ai/sessions/', 'sessionId'],
    new: (args) => args,
  },
  'GET ai sessions': {
    urlSplits: ['/slab/ai/sessions'],
    new: (args) => args,
  },
  'GET all notification settings': {
    urlSplits: ['/slab/notification-settings/settings'],
    new: (args) => (args ?? []).map((s: any) => NewNotificationSettingsFromWireFormat(s)),
  },
  'GET app version': {
    urlSplits: ['/version.json'],
    new: (args) => args,
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  },
  'GET async job detail': {
    urlSplits: ['/slab/async-jobs/', 'id'],
    new: (args) => NewAsyncJobDetailFromWireFormat(args),
  },
  'GET async job summaries': {
    urlSplits: ['/slab/async-jobs/summaries'],
    new: (args) => new List(NewAsyncJobSummaryFromWireFormat, args),
  },
  'GET companies': {
    urlSplits: ['/slab/companies'],
    new: (args) => new List(NewCompanyFromWireFormat, args),
  },
  'GET companies by activity ID': {
    urlSplits: ['/slab/activities/', 'id', '/companies'],
    new: (args) => (args ?? []).map((a: any) => NewCompanyFromWireFormat(a)),
  },
  'GET companies typeahead': {
    urlSplits: ['/slab/companies/typeahead'],
    new: (args) => args ?? [],
  },
  'GET company by ID': {
    urlSplits: ['/slab/companies/', 'id'],
    new: (args) => NewCompanyFromWireFormat(args),
  },
  'GET company category aggregations': {
    urlSplits: ['/slab/companies/stats'],
    new: (args) => (args ?? []).map((a: any) => NewCompanyCategoryAggFromWireFormat(a)),
  },
  'GET company contacts': {
    urlSplits: ['/slab/companies/', 'id', '/contacts'],
    new: (args) => (args ?? []).map((a: any) => NewContactFromWireFormat(a)),
  },
  'GET company dispatch customer matches': {
    urlSplits: ['/slab/companies/', 'id', '/dispatchcustomer-matches'],
    new: (args) => (args ?? []).map((a: any) => NewDispatchCustomerMatchInfoFromWireFormat(a)),
  },
  'GET company summaries': {
    urlSplits: ['/slab/companies/summaries'],
    new: (args) => new List(NewCompanySummary, args),
  },
  'GET competitor by ID': {
    urlSplits: ['/slab/competitors/', 'id'],
    new: (args) => NewCompetitorFromWireFormat(args),
  },
  'GET competitor plants': {
    urlSplits: ['/slab/competitors/plants'],
    new: (args) => new List(NewCompetitorPlantFromWireFormat, args),
  },
  'GET competitor products summaries by competitor ID': {
    urlSplits: ['/slab/competitors/', 'id', '/products/summaries'],
    new: (args) => new List(NewCompetitorProductSummary, args),
  },
  'GET competitors summaries': {
    urlSplits: ['/slab/competitors/summaries'],
    new: (args) => new List(NewCompetitorSummary, args),
  },
  'GET contact by ID': {
    urlSplits: ['/slab/contacts/', 'id'],
    new: (args) => NewContactFromWireFormat(args),
  },
  'GET contacts': {
    urlSplits: ['/slab/contacts'],
    new: (args) => new List(NewContactFromWireFormat, args),
  },
  'GET contacts by activity ID': {
    urlSplits: ['/slab/activities/', 'id', '/contacts'],
    new: (args) => (args ?? []).map((a: any) => NewContactFromWireFormat(a)),
  },
  'GET contacts by company IDs': {
    urlSplits: ['/slab/companies/contacts/by'],
    new: (args) => new List(NewContactFromWireFormat, args),
  },
  'GET contacts summaries': {
    urlSplits: ['/slab/contacts/summaries'],
    new: (args) => new List(NewContactSummaryFromWireFormat, args),
  },
  'GET custom field definitions': {
    urlSplits: ['/slab/customfielddefinitions'],
    new: (args) => new List(NewCustomFieldDefinitionFromWireFormat, args),
  },
  'GET customers performance': {
    urlSplits: ['/slab/actuals/customers-performance'],
    new: (args) => new List(NewActualsCustomerPerformanceSummaryFromWireFormat, args),
  },
  'GET dashboards': {
    urlSplits: ['/slab/dashboards/', 'kind'],
    new: (args) => (args ?? []).map((a: any) => NewSignedDashboardFromWireFormat(a)),
  },
  'GET dispatch customer aggregations': {
    urlSplits: ['/slab/dispatchcustomers/stats'],
    new: (args) => (args ?? []).map((a: any) => NewDispatchCustomerAggFromWireFormat(a)),
  },
  'GET dispatch customer summaries': {
    urlSplits: ['/slab/dispatchcustomers/summaries'],
    new: (args) => new List(NewDispatchCustomerSummaryFromWireFormat, args),
  },
  'GET dispatch customer to company possible matches': {
    urlSplits: ['/slab/dispatchcustomers/companymatches'],
    new: (args) => new List(NewDispatchCustomerToCompanyPossibleMatchesFromWireFormat, args),
  },
  'GET dispatch customers': {
    urlSplits: ['/slab/dispatchcustomers'],
    new: (args) => new List(NewDispatchCustomerFromWireFormat, args),
  },
  'GET divisions': {
    urlSplits: ['/slab/divisions'],
    new: (args) => new List(NewDivisionFromWireFormat, args),
  },
  'GET entity files by entity ID': {
    urlSplits: ['/slab/', 'entityPath', '/', 'id', '/files'],
    new: (args) => new List(NewFileFromWireFormat, args),
  },
  'GET file download url by file ID': {
    urlSplits: ['/slab/files/', 'id', '/download'],
    new: (args) => args as { url: string },
  },
  'GET forecast aggregations': {
    urlSplits: ['/slab/forecasts/stats'],
    new: (args) => NewForecastAggFromWireFormat(args),
  },
  'GET forecasts': {
    urlSplits: ['/slab/forecasts'],
    new: (args) => new List(NewForecastFromWireFormat, args),
  },
  'GET global search': {
    urlSplits: ['/slab/global-search'],
    new: (args) => args as GlobalSearchResponse,
  },
  'GET ignored dispatch customers': {
    urlSplits: ['/slab/dispatchcustomers/ignored'],
    new: (args) => new List(NewIgnoredDispatchCustomerFromWireFormat, args),
  },
  'GET imported discounts': {
    urlSplits: ['/slab/imported-discounts'],
    new: (args) => new List(NewImportedDiscountSummary, args),
  },
  'GET integrations': {
    urlSplits: ['/slab/integrations'],
    new: (args) => new List(NewIntegrationFromWireFormat, args),
  },
  'GET integrations by tenant ID as admin': {
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/integrations'],
    new: (args) => new List(NewIntegrationFromWireFormat, args),
  },
  'GET linked dispatch customers': {
    urlSplits: ['/slab/dispatchcustomers/linked'],
    new: (args) => new List(NewLinkedDispatchCustomerFromWireFormat, args),
  },
  'GET maps autocomplete': {
    urlSplits: ['/slab/maps/autocomplete'],
    new: (args) => (args ?? []).map((a: any) => NewAutocompletePredictionFromWireFormat(a)),
  },
  'GET maps conversion': {
    urlSplits: ['/slab/maps/convert'],
    new: (args) => NewLocationResultFromWireFormat(args),
  },
  'GET maps distance': {
    urlSplits: ['/slab/maps/distance'],
    new: (args) => NewDistanceResultFromWireFormat(args),
  },
  'GET maps place': {
    urlSplits: ['/slab/maps/place'],
    new: (args) => NewLocationResultFromWireFormat(args),
  },
  'GET market summaries': {
    urlSplits: ['/slab/markets/summaries'],
    new: (args) => new List(NewMarketSummaryFromWireFormat, args),
  },
  'GET market summaries as admin': {
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/markets/summaries'],
    new: (args) => new List(NewMarketSummaryFromWireFormat, args),
  },
  'GET markets': {
    urlSplits: ['/slab/markets'],
    new: (args) => new List(NewMarketFromWireFormat, args),
  },
  'GET matching imported discounts': {
    urlSplits: ['/slab/imported-discounts/matching'],
    new: (args) => (args ?? []).map((a: any) => NewImportedDiscountFromWireFormat(a)),
  },
  'GET material by ID': {
    urlSplits: ['/slab/materials/', 'id'],
    new: (args) => NewMaterialFromWireFormat(args),
  },
  'GET material summaries': {
    urlSplits: ['/slab/materials/summaries'],
    new: (args) => new List(NewMaterialSummary, args),
  },
  'GET material type aggregations': {
    urlSplits: ['/slab/materials/stats'],
    new: (args) => (args ?? []).map((a: any) => NewMaterialTypeAggFromWireFormat(a)),
  },
  'GET materials': {
    urlSplits: ['/slab/materials'],
    new: (args) => new List(NewMaterialFromWireFormat, args),
  },
  'GET materials by mix ID': {
    urlSplits: ['/slab/mix/', 'id', '/materials'],
    new: (args) => (args ?? []).map((a: any) => NewMixMaterialFromWireFormat(a)),
  },
  'GET materials by plant ID': {
    urlSplits: ['/slab/plants/', 'id', '/materials'],
    new: (args) => (args ?? []).map((a: any) => NewMaterialFromWireFormat(a)),
  },
  'GET mix by ID': {
    urlSplits: ['/slab/mixes/', 'id'],
    new: (args) => NewMixFromWireFormat(args),
  },
  'GET mix summaries': {
    urlSplits: ['/slab/mixes/summaries'],
    new: (args) => new List(NewMixSummary, args),
  },
  'GET mixes': {
    urlSplits: ['/slab/mixes'],
    new: (args) => new List(NewMixFromWireFormat, args),
  },
  'GET mixes by plant ID': {
    urlSplits: ['/slab/plants/', 'id', '/mixes'],
    new: (args) => (args ?? []).map((a: any) => NewMixFromWireFormat(a)),
  },
  'GET notification stats': {
    urlSplits: ['/slab/notifications/stats'],
    new: (args) => NewNotificationStatsFromWireFormat(args),
  },
  'GET notifications': {
    urlSplits: ['/slab/notifications'],
    new: (args) => new List(NewNotificationMessageFromWireFormat, args),
  },
  'GET nylas v3 grant info': {
    urlSplits: ['/slab/nylas/v3/grant/info'],
    new: (args) => NewAccountInfoOutputFromWireFormat(args),
  },
  'GET nylas v3 login': {
    urlSplits: ['/slab/nylas/v3/login/init'],
    new: (args) => NewAuthorizationOutputFromWireFormat(args),
  },
  'GET pdf templates': {
    urlSplits: ['/slab/pdftemplates'],
    new: (args) => new List(NewPdfTemplateFromWireFormat, args),
  },
  'GET planning budget approval by location ID and year ID': {
    urlSplits: ['/slab/planning/locations/', 'id', '/budget/', 'yearId', '/approval'],
    // An open budget renders a bare null.
    new: (args) => (hasValue(args) ? NewPlanningBudgetApprovalFromWireFormat(args) : null),
  },
  'GET planning budget by location ID and year ID': {
    urlSplits: ['/slab/planning/locations/', 'id', '/budget/', 'yearId'],
    new: (args) => (args ?? []).map((a: any) => NewPlanningBudgetEntryFromWireFormat(a)),
  },
  'GET planning forecast by location ID and year ID': {
    urlSplits: ['/slab/planning/locations/', 'id', '/forecast/', 'yearId'],
    new: (args) => (args ?? []).map((a: any) => NewPlanningForecastEntryFromWireFormat(a)),
  },
  'GET planning reporting groups': {
    urlSplits: ['/slab/planning/reporting-groups'],
    new: (args) => (args ?? []).map((a: any) => NewPlanningReportingGroupFromWireFormat(a)),
  },
  'GET planning rollup by year ID': {
    urlSplits: ['/slab/planning/budget/', 'yearId', '/rollup'],
    new: (args) => (args ?? []).map((a: any) => NewPlanningRollupCellFromWireFormat(a)),
  },
  'GET planning structure by location ID': {
    urlSplits: ['/slab/planning/locations/', 'id', '/structure'],
    new: (args) => (args ?? []).map((a: any) => NewPlanningNodeFromWireFormat(a)),
  },
  'GET planning years': {
    urlSplits: ['/slab/planning/years'],
    new: (args) => (args ?? []).map((a: any) => NewPlanningYearFromWireFormat(a)),
  },
  'GET plant by ID': {
    urlSplits: ['/slab/plants/', 'id'],
    new: (args) => NewPlantFromWireFormat(args),
  },
  'GET plant forecasts by plant ID': {
    urlSplits: ['/slab/plants/', 'id', '/forecasts'],
    new: (args) => (args ?? []).map((a: any) => NewForecastFromWireFormat(a)),
  },
  'GET plant materials by plant ID': {
    urlSplits: ['/slab/plants/', 'id', '/materials'],
    new: (args) => (args ?? []).map((a: any) => NewMaterialFromWireFormat(a)),
  },
  'GET plant products by plant ID': {
    urlSplits: ['/slab/plants/', 'id', '/products'],
    new: (args) => (args ?? []).map((a: any) => NewProductFromWireFormat(a)),
  },
  'GET plants': {
    urlSplits: ['/slab/plants'],
    new: (args) => new List(NewPlantFromWireFormat, args),
  },
  'GET plants performance': {
    urlSplits: ['/slab/actuals/plants-performance'],
    new: (args) => new List(NewActualsPlantPerformanceSummaryFromWireFormat, args),
  },
  'GET plants summaries': {
    urlSplits: ['/slab/plants/summaries'],
    new: (args) => new List(NewPlantSummaryFromWireFormat, args),
  },
  'GET product by ID': {
    urlSplits: ['/slab/products/', 'id'],
    new: (args) => NewProductFromWireFormat(args),
  },
  'GET product category aggregations': {
    urlSplits: ['/slab/products/stats'],
    new: (args) => (args ?? []).map((a: any) => NewProductCategoryAggFromWireFormat(a)),
  },
  'GET product summaries': {
    urlSplits: ['/slab/products/summaries'],
    new: (args) => new List(NewProductSummary, args),
  },
  'GET products': {
    urlSplits: ['/slab/products'],
    new: (args) => new List(NewProductFromWireFormat, args),
  },
  'GET products typeahead': {
    urlSplits: ['/slab/products/typeahead'],
    new: (args) => args ?? [],
  },
  'GET project by ID': {
    urlSplits: ['/slab/projects/', 'id'],
    new: (args) => NewProjectFromWireFormat(args),
  },
  'GET project companies by project ID': {
    urlSplits: ['/slab/projects/', 'id', '/companies'],
    new: (args) => (args ?? []).map((a: any) => NewProjectCompanyFromWireFormat(a)),
  },
  'GET project config by ID': {
    urlSplits: ['/slab/projectconfigs/', 'id'],
    new: (args) => NewProjectConfigFromWireFormat(args),
  },
  'GET project config products by project config ID': {
    urlSplits: ['/slab/projectconfigs/', 'id', '/products'],
    new: (args) => (args ?? []).map((a: any) => NewProjectConfigProductFromWireFormat(a)),
  },
  'GET project config summaries': {
    urlSplits: ['/slab/projectconfigs/summaries'],
    new: (args) => new List(NewProjectConfigSummary, args),
  },
  'GET project configs': {
    urlSplits: ['/slab/projectconfigs'],
    new: (args) => new List(NewProjectConfigFromWireFormat, args),
  },
  'GET project forecast summaries': {
    urlSplits: ['/slab/forecasts/summaries'],
    new: (args) => new List(NewProjectForecastSummaryFromWireFormat, args),
  },
  'GET project forecasts by project ID': {
    urlSplits: ['/slab/projects/', 'id', '/forecasts'],
    new: (args) => (args ?? []).map((a: any) => NewForecastFromWireFormat(a)),
  },
  'GET project loss reasons': {
    urlSplits: ['/slab/projectlossreasons'],
    new: (args) => new List(NewProjectLossReasonFromWireFormat, args),
  },
  'GET project map pins': {
    urlSplits: ['/slab/projects/map-pins'],
    new: (args) => (args ?? []).map((a: any) => NewProjectMapPinFromWireFormat(a)),
  },
  'GET project products by project ID': {
    urlSplits: ['/slab/projects/', 'id', '/products'],
    new: (args) => (args ?? []).map((a: any) => NewProjectProductFromWireFormat(a)),
  },
  'GET project quotes by project ID': {
    urlSplits: ['/slab/projects/', 'id', '/quotes'],
    new: (args) => (args ?? []).map((a: any) => NewQuoteFromWireFormat(a)),
  },
  'GET project status aggregations': {
    urlSplits: ['/slab/projects/stats'],
    new: (args) => (args ?? []).map((a: any) => NewProjectStatusAggFromWireFormat(a)),
  },
  'GET project statuses': {
    urlSplits: ['/slab/projectstatuses'],
    new: (args) => new List(NewProjectStatusFromWireFormat, args),
  },
  'GET project statuses as admin': {
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/projectstatuses'],
    new: (args) => new List(NewProjectStatusFromWireFormat, args),
  },
  'GET project summaries': {
    urlSplits: ['/slab/projects/summaries'],
    new: (args) => new List(NewProjectSummary, args),
  },
  'GET project summaries by company ID': {
    urlSplits: ['/slab/companies/', 'id', '/projects/summaries'],
    new: (args) => new List(NewProjectSummary, args),
  },
  'GET project summaries by contact ID': {
    urlSplits: ['/slab/contacts/', 'id', '/projects/summaries'],
    new: (args) => new List(NewProjectSummary, args),
  },
  'GET projects': {
    urlSplits: ['/slab/projects'],
    new: (args) => new List(NewProjectFromWireFormat, args),
  },
  'GET projects typeahead': {
    urlSplits: ['/slab/projects/typeahead'],
    new: (args) => args ?? [],
  },
  'GET quote bulk pricing update preview': {
    urlSplits: ['/slab/quotes/bulk-pricing-update-preview'],
    new: (args) => NewQuoteBulkPriceUpdatePreviewStatsFromWireFormat(args),
  },
  'GET quote by ID': {
    urlSplits: ['/slab/quotes/', 'id'],
    new: (args) => NewQuoteFromWireFormat(args),
  },
  'GET quote config by ID': {
    urlSplits: ['/slab/quoteconfigs/', 'id'],
    new: (args) => NewQuoteConfigFromWireFormat(args),
  },
  'GET quote configs': {
    urlSplits: ['/slab/quoteconfigs'],
    new: (args) => new List(NewQuoteConfigFromWireFormat, args),
  },
  'GET quote configs summaries': {
    urlSplits: ['/slab/quoteconfigs/summaries'],
    new: (args) => new List(NewQuoteConfigSummaryFromWireFormat, args),
  },
  'GET quote edit lock': {
    urlSplits: ['/slab/quotes/', 'id', '/lock'],
    new: (args) => (hasValue(args) && args !== '' ? args : null),
  },
  'GET quote escalations stats': {
    urlSplits: ['/slab/quotes/escalations/stats'],
    new: (args) => NewEscalationWindowStatsFromWireFormat(args),
  },
  'GET quote loss reasons': {
    urlSplits: ['/slab/quotelossreasons'],
    new: (args) => new List(NewQuoteLossReasonFromWireFormat, args),
  },
  'GET quote pdf by quote ID and template ID': {
    urlSplits: ['/slab/pdfgeneratorapi/', 'templateID', '/quote/', 'quoteID'],
    new: (args) => NewGeneratedPDFFromWireFormat(args),
  },
  'GET quote pdf input json by quote ID': {
    urlSplits: ['/slab/pdfgeneratorapi/quote/', 'quoteID'],
    new: (args) => JSON.stringify(args, undefined, 2),
  },
  'GET quote policies': {
    urlSplits: ['/slab/quotepolicies'],
    new: (args) => new List(NewQuotePolicyFromWireFormat, args),
  },
  'GET quote policy violations by quote ID': {
    urlSplits: ['/slab/quotes/', 'quoteID', '/policyviolations'],
    new: (args) => (args ?? []).map((a: any) => NewQuotePolicyViolationFromWireFormat(a)),
  },
  'GET quote price escalation summaries': {
    urlSplits: ['/slab/quotes/escalations/summaries'],
    new: (args) => new List(NewPriceEscalationQuoteSummary, args),
  },
  'GET quote price escalations': {
    urlSplits: ['/slab/quotes/escalations/earliest-in-range'],
    new: (args) => new List(NewPriceEscalationQuoteSummary, args),
  },
  'GET quote product summaries': {
    urlSplits: ['/slab/quoteproducts/summaries'],
    new: (args) => new List(NewQuoteProductSummary, args),
  },
  'GET quote products by quote ID': {
    urlSplits: ['/slab/quotes/', 'id', '/products'],
    new: (args) => (args ?? []).map((a: any) => NewQuoteProductFromWireFormat(a)),
  },
  'GET quote status aggregations': {
    urlSplits: ['/slab/quotes/stats'],
    new: (args) => (args ?? []).map((a: any) => NewQuoteStatusAggFromWireFormat(a)),
  },
  'GET quote statuses': {
    urlSplits: ['/slab/quotestatuses'],
    new: (args) => new List(NewQuoteStatusFromWireFormat, args),
  },
  'GET quote summaries': {
    urlSplits: ['/slab/quotes/summaries'],
    new: (args) => new List(NewQuoteSummary, args),
  },
  'GET quote suspended orders by quote ID': {
    urlSplits: ['/slab/quotes/', 'quoteID', '/suspended-orders'],
    new: (args) => (args ?? []).map((a: any) => NewQuoteSuspendedOrderFromWireFormat(a)),
  },
  'GET quotes': {
    urlSplits: ['/slab/quotes'],
    new: (args) => new List(NewQuoteFromWireFormat, args),
  },
  'GET quotes typeahead': {
    urlSplits: ['/slab/quotes/typeahead'],
    new: (args) => args ?? [],
  },
  'GET reminder system setting by ID': {
    urlSplits: ['/slab/reminders/system-settings/', 'id'],
    new: (args) => NewReminderSystemSettingFromWireFormat(args),
  },
  'GET reminder system setting summaries': {
    urlSplits: ['/slab/reminders/system-settings/summaries'],
    new: (args) => new List(NewReminderSystemSettingSummaryFromWireFormat, args),
  },
  'GET reminder user setting by ID': {
    urlSplits: ['/slab/reminders/user-settings/', 'id'],
    new: (args) => NewReminderUserSettingFromWireFormat(args),
  },
  'GET reminder user setting summaries': {
    urlSplits: ['/slab/reminders/user-settings/summaries'],
    new: (args) => new List(NewReminderUserSettingSummaryFromWireFormat, args),
  },
  'GET roles': {
    urlSplits: ['/slab/roles'],
    new: (args) => new List(NewRoleFromWireFormat, args),
  },
  'GET roles as admin': {
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/roles'],
    new: (args) => new List(NewRoleFromWireFormat, args),
  },
  'GET segments': {
    urlSplits: ['/slab/segments'],
    new: (args) => new List(NewSegmentFromWireFormat, args),
  },
  'GET signed url for csv file': {
    urlSplits: ['/slab/signedurl/files/csvimport'],
    new: (args) => args,
  },
  'GET tax codes': {
    urlSplits: ['/slab/taxcodes'],
    new: (args) => new List(NewTaxCodeFromWireFormat, args),
  },
  'GET tenant margins overview': {
    urlSplits: ['/slab/tenants/margins/overview'],
    new: (args) => NewTenantMarginOverviewFromWireFormat(args),
  },
  'GET tenant variance thresholds': {
    urlSplits: ['/slab/tenants/settings/variance-thresholds'],
    new: (args) => NewVarianceThresholdSettingsFromWireFormat(args),
  },
  'GET tenants as admin': {
    urlSplits: ['/slabadmin/tenants'],
    new: (args) => new List(NewTenantFromWireFormat, args),
  },
  'GET tier pricing adjusted': {
    urlSplits: ['/slab/tier-pricing/adjusted'],
    new: (args) => new List(NewAdjustedPricing, args),
  },
  'GET tier pricing adjusted by ID': {
    urlSplits: ['/slab/tier-pricing/adjusted/', 'id'],
    new: (args) => NewAdjustedPricing(args),
  },
  'GET tier pricing by company ID': {
    urlSplits: ['/slab/tier-pricing/by-company'],
    new: (args) => NewFixedPricingByCompany(args),
  },
  'GET tier pricing fixed': {
    urlSplits: ['/slab/tier-pricing/fixed'],
    new: (args) => new List(NewFixedPricing, args),
  },
  'GET tier pricing fixed by ID': {
    urlSplits: ['/slab/tier-pricing/fixed/', 'id'],
    new: (args) => NewFixedPricing(args),
  },
  'GET tier pricing imported': {
    urlSplits: ['/slab/tier-pricing/imported'],
    new: (args) => new List(NewImportedPricing, args),
  },
  'GET trucking type by ID': {
    urlSplits: ['/slab/trucking-types/', 'id'],
    new: (args) => NewTruckingTypeFromWireFormat(args),
  },
  'GET trucking type summaries': {
    urlSplits: ['/slab/trucking-types/summaries'],
    new: (args) => new List(NewTruckingTypeSummaryFromWireFormat, args),
  },
  'GET trucking types typeahead': {
    urlSplits: ['/slab/trucking-types/typeahead'],
    new: (args) => args ?? [],
  },
  'GET unlinked dispatch customers': {
    urlSplits: ['/slab/dispatchcustomers/unlinked'],
    new: (args) => new List(NewUnlinkedDispatchCustomerFromWireFormat, args),
  },
  'GET unmerged dispatch customers': {
    urlSplits: ['/slab/dispatchcustomers/unmerged'],
    new: (args) => new List(NewUnmergedDispatchCustomerFromWireFormat, args),
  },
  'GET user info': {
    urlSplits: ['/slab/userinfo'],
    new: (args) => NewUserInfoFromWireFormat(args),
  },
  'GET user summaries': {
    urlSplits: ['/slab/users/summaries'],
    new: (args) => new List(NewUserSummaryFromWireFormat, args),
  },
  'GET users': {
    urlSplits: ['/slab/users'],
    new: (args) => new List(NewUserFromWireFormat, args),
  },
  'GET users by role ID': {
    urlSplits: ['/slab/roles/', 'id', '/users'],
    new: (args) => (args ?? []).map((a: any) => NewUserFromWireFormat(a)),
  },
  'GET users by tenant ID as admin': {
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/users'],
    new: (args) => new List(NewUserFromWireFormat, args),
  },
  'GET users email signatures': {
    urlSplits: ['/slab/email-signatures'],
    new: (args) => new List(NewUserEmailSignatureFromWireFormat, args),
  },
  'GET variance alerts': {
    urlSplits: ['/slab/actuals/actuals-alerts'],
    new: (args) => new List((item: any) => item, args), // Return paginated variance alerts
  },

  // ---- MOBILE-ONLY ROUTES — no web equivalent. ----
  'GET notifications settings': {
    urlSplits: ['/slab/notification-settings/settings/', 'notificationType'],
    new: (args) => NewNotificationSettingsFromWireFormat(args),
  },
};

export const MutationRouteBarrelVals: Record<MutationRouteBarrelKeys, MutationBarrelVals> = {
  'DELETE file by ID': {
    method: 'DELETE',
    urlSplits: ['/slab/files/', 'id'],
    invalidations: ['GET entity files by entity ID'],
    new: (args) => NewFileFromWireFormat(args),
  },
  'DELETE pdf template by ID': {
    method: 'DELETE',
    urlSplits: ['/slab/pdftemplates/', 'id'],
    invalidations: ['GET pdf templates'],
    new: () => null,
  },
  'DELETE project loss reason by ID': {
    method: 'DELETE',
    urlSplits: ['/slab/projectlossreasons/', 'id'],
    invalidations: ['GET project loss reasons'],
    new: () => null,
  },
  'DELETE project status by ID': {
    method: 'DELETE',
    urlSplits: ['/slab/projectstatuses/', 'id'],
    invalidations: ['GET project statuses', 'GET project status aggregations'],
    new: () => null,
  },
  'DELETE push notification device': {
    method: 'DELETE',
    urlSplits: ['/slab/notification-settings/devices'],
    invalidations: [],
    new: () => null,
  },
  'DELETE quote edit lock': {
    method: 'DELETE',
    urlSplits: ['/slab/quotes/', 'id', '/lock'],
    invalidations: [],
    new: () => null,
  },
  'DELETE quote status by ID': {
    method: 'DELETE',
    urlSplits: ['/slab/quotestatuses/', 'id'],
    invalidations: ['GET quote statuses', 'GET quote status aggregations'],
    new: () => null,
  },
  'DELETE user email signature by ID': {
    method: 'DELETE',
    urlSplits: ['/slab/email-signatures/', 'id'],
    invalidations: ['GET users email signatures'],
    new: (args) => NewUserEmailSignatureFromWireFormat(args),
  },
  'POST activity': {
    method: 'POST',
    urlSplits: ['/slab/activities'],
    invalidations: [
      'GET activities',
      'GET activities by contact ID',
      'GET activities by company ID',
      'GET activities by project ID',
      'GET activities by user ID',
    ],
    new: (args) => NewActivityFromWireFormat(args),
  },
  'POST activity bulk edit': {
    method: 'POST',
    urlSplits: ['/slab/activities/actions/bulk-update'],
    invalidations: [
      'GET activities',
      'GET activities by contact ID',
      'GET activities by company ID',
      'GET activities by project ID',
      'GET activities by user ID',
      'GET activity by ID',
      'GET companies by activity ID',
      'GET contacts by activity ID',
      'GET reminder user setting summaries',
    ],
    new: () => null,
  },
  'POST ai chat': {
    method: 'POST',
    urlSplits: ['/slab/ai/chat'],
    invalidations: ['GET ai sessions'],
    new: (args) => args,
  },
  'POST ai greeting': {
    method: 'POST',
    urlSplits: ['/slab/ai/greet'],
    invalidations: ['GET ai sessions'],
    new: (args) => args,
  },
  'POST ai search': {
    method: 'POST',
    urlSplits: ['/slab/ai/search'],
    invalidations: [],
    new: (args) => args,
  },
  'POST apply quote price escalations': {
    method: 'POST',
    urlSplits: ['/slab/quotes/escalations/apply'],
    invalidations: ['GET async job summaries'],
    new: (args) => args,
  },
  'POST archive activity by ID': {
    method: 'POST',
    urlSplits: ['/slab/activities/', 'id', '/archive'],
    invalidations: [
      'GET activities',
      'GET activities by contact ID',
      'GET activities by company ID',
      'GET activities by project ID',
      'GET activities by user ID',
      'GET activity by ID',
      'GET companies by activity ID',
      'GET contacts by activity ID',
      'GET reminder user setting summaries',
      'GET notification stats',
    ],
    new: (args) => NewActivityFromWireFormat(args),
  },
  'POST archive adjusted pricing by ID': {
    method: 'POST',
    urlSplits: ['/slab/tier-pricing/adjusted/', 'id', '/archive'],
    invalidations: [
      'GET tier pricing adjusted',
      'GET tier pricing adjusted by ID',
      'GET tier pricing by company ID',
    ],
    new: (args) => NewAdjustedPricing(args),
  },
  'POST archive company by ID': {
    method: 'POST',
    urlSplits: ['/slab/companies/', 'id', '/archive'],
    invalidations: [
      'GET contacts',
      'GET contacts summaries',
      'GET contacts by company IDs',
      'GET contact by ID',
      'GET companies',
      'GET companies typeahead',
      'GET company summaries',
      'GET company by ID',
      'GET company contacts',
      'GET company category aggregations',
      'GET dispatch customer aggregations',
      'GET dispatch customer summaries',
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project quotes by project ID',
      'GET project companies by project ID',
      'GET project config by ID',
      'GET project config summaries',
      'GET project configs',
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
    ],
    new: (args) => NewCompanyFromWireFormat(args),
  },
  'POST archive competitor by ID': {
    method: 'POST',
    urlSplits: ['/slab/competitors/', 'id', '/archive'],
    invalidations: [
      'GET competitor by ID',
      'GET competitors summaries',
      'GET competitor plants',
      'GET competitor products summaries by competitor ID',
      'GET project by ID',
      'GET quote by ID',
    ],
    new: (args) => NewCompetitorFromWireFormat(args),
  },
  'POST archive contact by ID': {
    method: 'POST',
    urlSplits: ['/slab/contacts/', 'id', '/archive'],
    invalidations: [
      'GET contacts',
      'GET contacts summaries',
      'GET contacts by company IDs',
      'GET contact by ID',
      'GET company contacts',
      'GET project quotes by project ID',
      'GET project companies by project ID',
      'GET project config by ID',
      'GET project configs',
    ],
    new: (args) => NewContactFromWireFormat(args),
  },
  'POST archive fixed pricing by ID': {
    method: 'POST',
    urlSplits: ['/slab/tier-pricing/fixed/', 'id', '/archive'],
    invalidations: [
      'GET tier pricing fixed',
      'GET tier pricing by company ID',
      'GET tier pricing fixed by ID',
    ],
    new: (args) => NewFixedPricing(args),
  },
  'POST archive imported pricing by ID': {
    method: 'POST',
    urlSplits: ['/slab/tier-pricing/imported/', 'id', '/archive'],
    invalidations: ['GET tier pricing imported', 'GET tier pricing by company ID'],
    new: (args) => NewImportedPricing(args),
  },
  'POST archive material by ID': {
    method: 'POST',
    urlSplits: ['/slab/materials/', 'id', '/archive'],
    invalidations: [
      'GET materials',
      'GET material summaries',
      'GET material type aggregations',
      'GET materials by plant ID',
      'GET material by ID',
      'GET materials by mix ID',
      'GET mixes',
      'GET mix summaries',
      'GET mixes by plant ID',
      'GET mix by ID',
      'GET plant materials by plant ID',
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET plant products by plant ID',
      'GET project config products by project config ID',
      'GET project products by project ID',
      'GET quote products by quote ID',
    ],
    new: (args) => NewMaterialFromWireFormat(args),
  },
  'POST archive mix by ID': {
    method: 'POST',
    urlSplits: ['/slab/mixes/', 'id', '/archive'],
    invalidations: [
      'GET mixes',
      'GET mix summaries',
      'GET mixes by plant ID',
      'GET mix by ID',
      'GET materials by mix ID',
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET plant products by plant ID',
      'GET project config products by project config ID',
      'GET project products by project ID',
      'GET quote products by quote ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
    ],
    new: (args) => NewMixFromWireFormat(args),
  },
  'POST archive plant by ID': {
    method: 'POST',
    urlSplits: ['/slab/plants/', 'id', '/archive'],
    invalidations: [
      'GET plant by ID',
      'GET plants',
      'GET plants summaries',
      'GET quote by ID',
      'GET project by ID',
      'GET material by ID',
      'GET mix by ID',
      'GET product by ID',
      'GET quote config by ID',
      'GET project config by ID',
      'GET planning rollup by year ID',
      'GET planning reporting groups',
    ],
    new: (args) => NewPlantFromWireFormat(args),
  },
  'POST archive product by ID': {
    method: 'POST',
    urlSplits: ['/slab/products/', 'id', '/archive'],
    invalidations: [
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET project config products by project config ID',
      'GET project products by project ID',
      'GET quote products by quote ID',
      'GET project quotes by project ID',
      'GET plant products by plant ID',
      'GET quote configs',
      'GET quote configs summaries',
      'GET quote config by ID',
    ],
    new: (args) => NewProductFromWireFormat(args),
  },
  'POST archive project by ID': {
    method: 'POST',
    urlSplits: ['/slab/projects/', 'id', '/archive'],
    invalidations: [
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project by ID',
      'GET project products by project ID',
      'GET project companies by project ID',
      'GET project status aggregations',
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET quote suspended orders by quote ID',
      'GET project quotes by project ID',
      'GET maps distance',
      'GET project forecasts by project ID',
      'GET forecasts',
      'GET project forecast summaries',
      'GET forecast aggregations',
      'GET reminder user setting summaries',
    ],
    new: (args) => NewProjectFromWireFormat(args),
  },
  'POST archive project config by ID': {
    method: 'POST',
    urlSplits: ['/slab/projectconfigs/', 'id', '/archive'],
    invalidations: [
      'GET project configs',
      'GET project config by ID',
      'GET project config products by project config ID',
      'GET project config summaries',
    ],
    new: (args) => NewProjectConfigFromWireFormat(args),
  },
  'POST archive quote by ID': {
    method: 'POST',
    urlSplits: ['/slab/quotes/', 'id', '/archive'],
    invalidations: [
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET quote policy violations by quote ID',
      'GET quote products by quote ID',
      'GET quote suspended orders by quote ID',
      'GET project quotes by project ID',
      'GET reminder user setting summaries',
    ],
    new: (args) => NewQuoteArchiveResultFromWireFormat(args),
  },
  'POST archive quote config by ID': {
    method: 'POST',
    urlSplits: ['/slab/quoteconfigs/', 'id', '/archive'],
    invalidations: ['GET quote configs', 'GET quote config by ID', 'GET quote configs summaries'],
    new: (args) => NewQuoteConfigFromWireFormat(args),
  },
  'POST archive quote loss reason by ID': {
    method: 'POST',
    urlSplits: ['/slab/quotelossreasons/', 'id', '/archive'],
    invalidations: ['GET quote loss reasons'],
    new: (args) => NewQuoteLossReasonFromWireFormat(args),
  },
  'POST archive reminder system setting by ID': {
    method: 'POST',
    urlSplits: ['/slab/reminders/system-settings/', 'id', '/archive'],
    invalidations: ['GET reminder system setting by ID', 'GET reminder system setting summaries'],
    new: (args) => NewReminderSystemSettingSummaryFromWireFormat(args),
  },
  'POST archive reminder user setting by ID': {
    method: 'POST',
    urlSplits: ['/slab/reminders/user-settings/', 'id', '/archive'],
    invalidations: [
      'GET reminder user setting by ID',
      'GET reminder user setting summaries',
      'GET notification stats',
    ],
    new: (args) => NewReminderUserSettingFromWireFormat(args),
  },
  'POST archive trucking type by ID': {
    method: 'POST',
    urlSplits: ['/slab/trucking-types/', 'id', '/archive'],
    invalidations: [
      'GET trucking type by ID',
      'GET trucking type summaries',
      'GET trucking types typeahead',
    ],
    new: (args) => NewTruckingTypeFromWireFormat(args),
  },
  'POST bulk archive notifications': {
    method: 'POST',
    urlSplits: ['/slab/notifications/bulk-archive'],
    invalidations: ['GET notifications', 'GET notification stats'],
    new: (args) => args,
  },
  'POST bulk notifications read status': {
    method: 'POST',
    urlSplits: ['/slab/notifications/bulk-read-status'],
    invalidations: ['GET notifications', 'GET notification stats'],
    new: (args) => args,
  },
  'POST bulk update reminder user settings': {
    method: 'POST',
    urlSplits: ['/slab/reminders/user-settings/actions/bulk-update'],
    invalidations: [
      'GET reminder user setting by ID',
      'GET reminder user setting summaries',
      'GET notification stats',
    ],
    new: (args) => args,
  },
  'POST check quote for policy violations': {
    method: 'POST',
    urlSplits: ['/slab/quotes/checkpolicies'],
    invalidations: [],
    new: (args) => NewCheckQuotePoliciesResultsFromWireFormat(args),
  },
  'POST company': {
    method: 'POST',
    urlSplits: ['/slab/companies'],
    invalidations: [
      'GET companies',
      'GET companies typeahead',
      'GET company summaries',
      'GET company by ID',
      'GET company contacts',
      'GET company category aggregations',
      'GET dispatch customer aggregations',
      'GET dispatch customer summaries',
      'GET unlinked dispatch customers',
      'GET unmerged dispatch customers',
      'GET linked dispatch customers',
    ],
    new: (args) => NewCompanyFromWireFormat(args),
  },
  'POST company bulk edit': {
    method: 'POST',
    urlSplits: ['/slab/companies/actions/bulk-update'],
    invalidations: [
      'GET contacts',
      'GET contacts summaries',
      'GET contacts by company IDs',
      'GET contact by ID',
      'GET companies',
      'GET companies typeahead',
      'GET company summaries',
      'GET company by ID',
      'GET company contacts',
      'GET company category aggregations',
      'GET dispatch customer aggregations',
      'GET dispatch customer summaries',
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project quotes by project ID',
      'GET project companies by project ID',
      'GET project config by ID',
      'GET project config summaries',
      'GET project configs',
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
    ],
    new: () => null,
  },
  'POST competitor': {
    method: 'POST',
    urlSplits: ['/slab/competitors'],
    invalidations: [
      'GET competitors summaries',
      'GET competitor by ID',
      'GET competitor plants',
      'GET competitor products summaries by competitor ID',
    ],
    new: (args) => NewCompetitorFromWireFormat(args),
  },
  'POST contact': {
    method: 'POST',
    urlSplits: ['/slab/contacts'],
    invalidations: [
      'GET contacts',
      'GET contacts summaries',
      'GET contacts by company IDs',
      'GET company contacts',
    ],
    new: (args) => NewContactFromWireFormat(args),
  },
  'POST division': {
    method: 'POST',
    urlSplits: ['/slab/divisions'],
    invalidations: ['GET divisions'],
    new: (args) => NewDivisionFromWireFormat(args),
  },
  'POST file': {
    method: 'POST',
    urlSplits: ['/slab/files'],
    invalidations: ['GET entity files by entity ID'],
    new: (args) => NewFileFromWireFormat(args),
  },
  'POST import companies': {
    method: 'POST',
    urlSplits: ['/slab/companies/import'],
    invalidations: [
      'GET companies',
      'GET companies typeahead',
      'GET company summaries',
      'GET company by ID',
      'GET company contacts',
      'GET company category aggregations',
      'GET dispatch customer aggregations',
      'GET dispatch customer summaries',
    ],
    new: () => null,
  },
  'POST import competitors': {
    method: 'POST',
    urlSplits: ['/slab/competitors/import'],
    invalidations: [
      'GET competitors summaries',
      'GET competitor by ID',
      'GET competitor plants',
      'GET competitor products summaries by competitor ID',
    ],
    new: () => null,
  },
  'POST import contacts': {
    method: 'POST',
    urlSplits: ['/slab/contacts/import'],
    invalidations: [
      'GET contacts',
      'GET contacts summaries',
      'GET contacts by company IDs',
      'GET company contacts',
    ],
    new: () => null,
  },
  'POST import forecasts': {
    method: 'POST',
    urlSplits: ['/slab/forecasts/import'],
    invalidations: [
      'GET plants',
      'GET forecasts',
      'GET project forecasts by project ID',
      'GET project forecast summaries',
      'GET plant forecasts by plant ID',
      'GET forecast aggregations',
    ],
    new: () => null,
  },
  'POST import materials': {
    method: 'POST',
    urlSplits: ['/slab/materials/import'],
    invalidations: [
      'GET materials',
      'GET material summaries',
      'GET material type aggregations',
      'GET materials by plant ID',
      'GET plant materials by plant ID',
    ],
    new: () => null,
  },
  'POST import mixes': {
    method: 'POST',
    urlSplits: ['/slab/mixes/import'],
    invalidations: ['GET mixes', 'GET mix summaries', 'GET mixes by plant ID'],
    new: () => null,
  },
  'POST import plants': {
    method: 'POST',
    urlSplits: ['/slab/plants/import'],
    invalidations: ['GET plants', 'GET plants summaries'],
    new: () => null,
  },
  'POST import products': {
    method: 'POST',
    urlSplits: ['/slab/products/import'],
    invalidations: [
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET plant products by plant ID',
    ],
    new: () => null,
  },
  'POST import projects': {
    method: 'POST',
    urlSplits: ['/slab/projects/import'],
    invalidations: [
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project status aggregations',
      'GET forecasts',
      'GET project forecast summaries',
      'GET forecast aggregations',
    ],
    new: () => null,
  },
  'POST import quotes': {
    method: 'POST',
    urlSplits: ['/slab/quotes/import'],
    invalidations: [
      'GET quotes',
      'GET quote by ID',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote products by quote ID',
      'GET quote suspended orders by quote ID',
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project by ID',
      'GET project quotes by project ID',
    ],
    new: () => null,
  },
  'POST integration archive as admin': {
    method: 'POST',
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/integrations/', 'id', '/archive'],
    invalidations: ['GET integrations by tenant ID as admin'],
    new: (args) => NewIntegrationFromWireFormat(args),
  },
  'POST integration as admin': {
    method: 'POST',
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/integrations'],
    invalidations: ['GET integrations by tenant ID as admin'],
    new: (args) => NewIntegrationFromWireFormat(args),
  },
  'POST maps distance from points': {
    method: 'POST',
    invalidations: [],
    urlSplits: ['/slab/maps/distancefrompoints'],
    new: (args) => NewDistanceResultFromWireFormat(args),
  },
  'POST mark all notifications as read': {
    method: 'POST',
    urlSplits: ['/slab/notifications/mark-all-as-read'],
    invalidations: ['GET notifications', 'GET notification stats'],
    new: (args) => args,
  },
  'POST mark quote as sent': {
    method: 'POST',
    urlSplits: ['/slab/quotes/', 'id', '/marksent'],
    invalidations: [
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project by ID',
      'GET project quotes by project ID',
    ],
    new: (args) => NewQuoteFromWireFormat(args),
  },
  'POST market': {
    method: 'POST',
    urlSplits: ['/slab/markets'],
    invalidations: [
      'GET markets',
      'GET market summaries',
      'GET user info',
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
      'GET divisions',
    ],
    new: (args) => NewMarketFromWireFormat(args),
  },
  'POST material': {
    method: 'POST',
    urlSplits: ['/slab/materials'],
    invalidations: [
      'GET materials',
      'GET material summaries',
      'GET material type aggregations',
      'GET materials by plant ID',
      'GET plant materials by plant ID',
    ],
    new: (args) => NewMaterialFromWireFormat(args),
  },
  'POST mix': {
    method: 'POST',
    urlSplits: ['/slab/mixes'],
    invalidations: ['GET mixes', 'GET mix summaries', 'GET mixes by plant ID'],
    new: (args) => NewMixFromWireFormat(args),
  },
  'POST nylas v3 code': {
    method: 'POST',
    urlSplits: ['/slab/nylas/v3/login/token'],
    invalidations: ['GET nylas v3 login', 'GET nylas v3 grant info'],
    new: (args) => NewAuthorizationTokenOutputFromWireFormat(args),
  },
  'POST nylas v3 message': {
    method: 'POST',
    urlSplits: ['/slab/nylas/v3/message/send'],
    invalidations: ['GET entity files by entity ID'],
    new: (args) => NewSendMessageOutputFromWireFormat(args),
  },
  'POST nylas v3 revoke grant': {
    method: 'POST',
    urlSplits: ['/slab/nylas/v3/grant/revoke'],
    invalidations: ['GET nylas v3 grant info'],
    new: (args) => NewRevokeTokenOutputFromWireFormat(args),
  },
  'POST pdf template': {
    method: 'POST',
    urlSplits: ['/slab/pdftemplates'],
    invalidations: ['GET pdf templates'],
    new: (args) => NewPdfTemplateFromWireFormat(args),
  },
  'POST planning budget approval by location ID and year ID': {
    method: 'POST',
    urlSplits: ['/slab/planning/locations/', 'id', '/budget/', 'yearId', '/approval'],
    invalidations: [],
    new: (args) => NewPlanningBudgetApprovalFromWireFormat(args),
  },
  'POST planning forecast revert by location ID and year ID': {
    method: 'POST',
    urlSplits: ['/slab/planning/locations/', 'id', '/forecast/', 'yearId', '/revert'],
    // The reply is the year's whole forecast, which the caller writes into the cache itself.
    invalidations: [],
    new: (args) =>
      Array.isArray(args) ? args.map((a: any) => NewPlanningForecastEntryFromWireFormat(a)) : [],
  },
  'POST planning node': {
    method: 'POST',
    urlSplits: ['/slab/planning/nodes'],
    invalidations: ['GET planning structure by location ID'],
    new: (args) => NewPlanningNodeFromWireFormat(args),
  },
  'POST planning product by node ID': {
    method: 'POST',
    urlSplits: ['/slab/planning/nodes/', 'id', '/products'],
    invalidations: ['GET planning structure by location ID'],
    new: (args) => NewPlanningProductFromWireFormat(args),
  },
  'POST planning reporting group': {
    method: 'POST',
    urlSplits: ['/slab/planning/reporting-groups'],
    invalidations: ['GET planning reporting groups'],
    new: (args) => NewPlanningReportingGroupFromWireFormat(args),
  },
  'POST planning reporting groups reset': {
    method: 'POST',
    urlSplits: ['/slab/planning/reporting-groups/reset'],
    invalidations: ['GET planning reporting groups'],
    // The route list test calls new({}) on every mutation, and a bare array has no {} form.
    new: (args) =>
      Array.isArray(args) ? args.map((a: any) => NewPlanningReportingGroupFromWireFormat(a)) : [],
  },
  'PUT planning reporting group by ID': {
    method: 'PUT',
    urlSplits: ['/slab/planning/reporting-groups/', 'id'],
    invalidations: ['GET planning reporting groups'],
    new: (args) => NewPlanningReportingGroupFromWireFormat(args),
  },
  'PUT planning reporting group location by plant ID': {
    method: 'PUT',
    urlSplits: ['/slab/planning/reporting-group-locations/', 'plantId'],
    invalidations: ['GET planning reporting groups'],
    new: () => null,
  },
  'DELETE planning reporting group by ID': {
    method: 'DELETE',
    urlSplits: ['/slab/planning/reporting-groups/', 'id'],
    invalidations: ['GET planning reporting groups'],
    new: () => null,
  },
  'POST planning year': {
    method: 'POST',
    urlSplits: ['/slab/planning/years'],
    invalidations: ['GET planning years'],
    new: (args) => NewPlanningYearFromWireFormat(args),
  },
  'POST plant': {
    method: 'POST',
    urlSplits: ['/slab/plants'],
    invalidations: [
      'GET plants',
      'GET plants summaries',
      'GET forecasts',
      'GET project forecast summaries',
      'GET forecast aggregations',
      'GET materials',
      'GET material summaries',
      'GET material type aggregations',
      'GET materials by plant ID',
      'GET mixes',
      'GET mix summaries',
      'GET mixes by plant ID',
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
    ],
    new: (args) => NewPlantFromWireFormat(args),
  },
  'POST plant bulk edit': {
    method: 'POST',
    urlSplits: ['/slab/plants/actions/bulk-update'],
    invalidations: [
      'GET plants',
      'GET plants summaries',
      'GET plant by ID',
      'GET plant forecasts by plant ID',
      'GET plant materials by plant ID',
      'GET plant products by plant ID',
      'GET maps distance',
      'GET materials',
      'GET material summaries',
      'GET material type aggregations',
      'GET materials by plant ID',
      'GET material by ID',
      'GET mixes',
      'GET mix summaries',
      'GET mixes by plant ID',
      'GET mix by ID',
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET projects',
      'GET projects typeahead',
      'GET project configs',
      'GET project config summaries',
      'GET project config products by project config ID',
      'GET project config by ID',
      'GET project products by project ID',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project by ID',
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET quote products by quote ID',
      'GET quote configs',
      'GET quote configs summaries',
      'GET quote config by ID',
      'GET forecasts',
      'GET project forecast summaries',
      'GET forecast aggregations',
    ],
    new: () => null,
  },
  'POST product': {
    method: 'POST',
    urlSplits: ['/slab/products'],
    invalidations: [
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET plant products by plant ID',
      'GET user info',
    ],
    new: (args) => NewProductFromWireFormat(args),
  },
  'POST project': {
    method: 'POST',
    urlSplits: ['/slab/projects'],
    invalidations: [
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project status aggregations',
      'GET forecasts',
      'GET project forecast summaries',
      'GET forecast aggregations',
      'GET project companies by project ID',
    ],
    new: (args) => NewProjectFromWireFormat(args),
  },
  'POST project bulk edit': {
    method: 'POST',
    urlSplits: ['/slab/projects/actions/bulk-update'],
    invalidations: [
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project by ID',
      'GET project products by project ID',
      'GET project companies by project ID',
      'GET project status aggregations',
      'GET reminder user setting summaries',
    ],
    new: () => null,
  },
  'POST project config': {
    method: 'POST',
    urlSplits: ['/slab/projectconfigs'],
    invalidations: [
      'GET project configs',
      'GET project config by ID',
      'GET project config products by project config ID',
      'GET project config summaries',
    ],
    new: (args) => NewProjectConfigFromWireFormat(args),
  },
  'POST project loss reason': {
    method: 'POST',
    urlSplits: ['/slab/projectlossreasons'],
    invalidations: ['GET project loss reasons'],
    new: (args) => NewProjectLossReasonFromWireFormat(args),
  },
  'POST project status': {
    method: 'POST',
    urlSplits: ['/slab/projectstatuses'],
    invalidations: ['GET project statuses', 'GET project status aggregations'],
    new: (args) => NewProjectStatusFromWireFormat(args),
  },
  'POST project status bulk edit': {
    method: 'POST',
    urlSplits: ['/slab/projectstatuses/actions/bulk-update'],
    invalidations: ['GET project statuses', 'GET project status aggregations', 'GET projects'],
    new: () => null,
  },
  'POST push notification device': {
    method: 'POST',
    urlSplits: ['/slab/notification-settings/devices'],
    invalidations: ['GET all notification settings'],
    new: (args) => NewPushNotificationDeviceFromWireFormat(args),
  },
  'POST quote': {
    method: 'POST',
    urlSplits: ['/slab/quotes'],
    invalidations: [
      'GET quotes',
      'GET quote price escalations',
      'GET quote by ID',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote products by quote ID',
      'GET quote suspended orders by quote ID',
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project by ID',
      'GET project quotes by project ID',
    ],
    new: (args) => NewQuoteFromWireFormat(args),
  },
  'POST quote bulk edit': {
    method: 'POST',
    urlSplits: ['/slab/quotes/actions/bulk-update'],
    invalidations: [
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote price escalations',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET quote policy violations by quote ID',
      'GET quote products by quote ID',
      'GET project quotes by project ID',
      'GET reminder user setting summaries',
    ],
    new: () => null,
  },
  'POST quote bulk pricing update': {
    method: 'POST',
    urlSplits: ['/slab/quotes/bulk-pricing-update'],
    invalidations: [
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote price escalations',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote products by quote ID',
      'GET project quotes by project ID',
      'GET quote bulk pricing update preview',
      'GET async job summaries',
    ],
    new: (args) => args,
  },
  'POST quote config': {
    method: 'POST',
    urlSplits: ['/slab/quoteconfigs'],
    invalidations: ['GET quote configs', 'GET quote configs summaries'],
    new: (args) => NewQuoteConfigFromWireFormat(args),
  },
  'POST quote edit lock': {
    method: 'POST',
    urlSplits: ['/slab/quotes/', 'id', '/lock'],
    invalidations: [],
    new: (args) => args,
  },
  'POST quote loss reason': {
    method: 'POST',
    urlSplits: ['/slab/quotelossreasons'],
    invalidations: ['GET quote loss reasons'],
    new: (args) => NewQuoteLossReasonFromWireFormat(args),
  },
  'POST quote policy': {
    method: 'POST',
    urlSplits: ['/slab/quotepolicies'],
    invalidations: ['GET quote policies'],
    new: (args) => NewQuoteConfigFromWireFormat(args),
  },
  'POST quote status': {
    method: 'POST',
    urlSplits: ['/slab/quotestatuses'],
    invalidations: ['GET quote statuses', 'GET quote status aggregations'],
    new: (args) => new List(NewQuoteStatusFromWireFormat, args),
  },
  'POST quote status bulk edit': {
    method: 'POST',
    urlSplits: ['/slab/quotestatuses/actions/bulk-update'],
    invalidations: ['GET quote statuses', 'GET quote status aggregations', 'GET quotes'],
    new: () => null,
  },
  'POST referral': {
    method: 'POST',
    urlSplits: ['/slab/referrals'],
    invalidations: [],
    new: (args) => NewReferralInviteRequest(args),
  },
  'POST reminder system setting': {
    method: 'POST',
    urlSplits: ['/slab/reminders/system-settings'],
    invalidations: ['GET reminder system setting by ID', 'GET reminder system setting summaries'],
    new: (args) => NewReminderSystemSettingFromWireFormat(args),
  },
  'POST reminder user setting': {
    method: 'POST',
    urlSplits: ['/slab/reminders/user-settings'],
    invalidations: [
      'GET reminder user setting by ID',
      'GET reminder user setting summaries',
      'GET notification stats',
    ],
    new: (args) => NewReminderUserSettingFromWireFormat(args),
  },
  'POST role': {
    method: 'POST',
    urlSplits: ['/slab/roles'],
    invalidations: [
      'GET roles',
      'GET user info',
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewRoleFromWireFormat(args),
  },
  'POST signed url for file': {
    method: 'POST',
    urlSplits: ['/slab/files/signedurl'],
    invalidations: [],
    new: (args) => args,
  },
  'POST tier pricing adjusted': {
    method: 'POST',
    urlSplits: ['/slab/tier-pricing/adjusted'],
    invalidations: ['GET tier pricing adjusted', 'GET tier pricing by company ID'],
    new: (args) => NewAdjustedPricing(args),
  },
  'POST tier pricing fixed': {
    method: 'POST',
    urlSplits: ['/slab/tier-pricing/fixed'],
    invalidations: ['GET tier pricing fixed', 'GET tier pricing by company ID'],
    new: (args) => NewFixedPricing(args),
  },
  'POST toggle reminder system setting status by ID': {
    method: 'POST',
    urlSplits: ['/slab/reminders/system-settings/', 'id', '/status'],
    invalidations: ['GET reminder system setting by ID', 'GET reminder system setting summaries'],
    new: (args) => NewReminderSystemSettingSummaryFromWireFormat(args),
  },
  'POST trucking types': {
    method: 'POST',
    urlSplits: ['/slab/trucking-types'],
    invalidations: [
      'GET trucking type by ID',
      'GET trucking type summaries',
      'GET trucking types typeahead',
    ],
    new: (args) => NewTruckingTypeFromWireFormat(args),
  },
  'POST user': {
    method: 'POST',
    urlSplits: ['/slab/users'],
    invalidations: [
      'GET markets',
      'GET market summaries',
      'GET user info',
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewUserFromWireFormat(args),
  },
  'POST user activate': {
    method: 'POST',
    urlSplits: ['/slab/users/', 'id', '/activate'],
    invalidations: [
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewUserFromWireFormat(args),
  },
  'POST user activate as admin': {
    method: 'POST',
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/users/', 'id', '/activate'],
    invalidations: [
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewUserFromWireFormat(args),
  },
  'POST user as admin': {
    method: 'POST',
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/users'],
    invalidations: [
      'GET markets',
      'GET market summaries',
      'GET user info',
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewUserFromWireFormat(args),
  },
  'POST user deactivate': {
    method: 'POST',
    urlSplits: ['/slab/users/', 'id', '/deactivate'],
    invalidations: [
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewUserFromWireFormat(args),
  },
  'POST user deactivate as admin': {
    method: 'POST',
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/users/', 'id', '/deactivate'],
    invalidations: [
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewUserFromWireFormat(args),
  },
  'POST user email signature': {
    method: 'POST',
    urlSplits: ['/slab/email-signatures'],
    invalidations: ['GET users email signatures'],
    new: (args) => NewUserEmailSignatureFromWireFormat(args),
  },
  'PUT activity by ID': {
    method: 'PUT',
    urlSplits: ['/slab/activities/', 'id'],
    invalidations: [
      'GET activities',
      'GET activities by contact ID',
      'GET activities by company ID',
      'GET activities by project ID',
      'GET activities by user ID',
      'GET activity by ID',
      'GET companies by activity ID',
      'GET contacts by activity ID',
      'GET reminder user setting summaries',
    ],
    new: (args) => NewActivityFromWireFormat(args),
  },
  'PUT approved quote by ID': {
    method: 'PUT',
    urlSplits: ['/slab/quotes/', 'quoteID', '/update-approved-quote'],
    invalidations: [
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET quote products by quote ID',
      'GET project quotes by project ID',
    ],
    new: (args) => NewQuoteFromWireFormat(args),
  },
  'PUT company by ID': {
    method: 'PUT',
    urlSplits: ['/slab/companies/', 'id'],
    invalidations: [
      'GET contacts',
      'GET contacts summaries',
      'GET contacts by company IDs',
      'GET contact by ID',
      'GET companies',
      'GET companies typeahead',
      'GET company summaries',
      'GET company by ID',
      'GET company contacts',
      'GET company category aggregations',
      'GET dispatch customer aggregations',
      'GET dispatch customer summaries',
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project quotes by project ID',
      'GET project companies by project ID',
      'GET project config by ID',
      'GET project config summaries',
      'GET project configs',
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET unlinked dispatch customers',
      'GET unmerged dispatch customers',
      'GET linked dispatch customers',
      'GET company dispatch customer matches',
    ],
    new: (args) => NewCompanyFromWireFormat(args),
  },
  'PUT competitor by ID': {
    method: 'PUT',
    urlSplits: ['/slab/competitors/', 'id'],
    invalidations: [
      'GET competitors summaries',
      'GET competitor by ID',
      'GET competitor plants',
      'GET competitor products summaries by competitor ID',
    ],
    new: (args) => NewCompetitorFromWireFormat(args),
  },
  'PUT contact by ID': {
    method: 'PUT',
    urlSplits: ['/slab/contacts/', 'id'],
    invalidations: [
      'GET contacts',
      'GET contacts summaries',
      'GET contacts by company IDs',
      'GET contact by ID',
      'GET company contacts',
      'GET project quotes by project ID',
      'GET project companies by project ID',
      'GET project config by ID',
      'GET project configs',
    ],
    new: (args) => NewContactFromWireFormat(args),
  },
  'PUT dispatch customers ignore by ID': {
    method: 'PUT',
    urlSplits: ['/slab/dispatchcustomers/ignore/', 'id'],
    invalidations: [
      'GET dispatch customers',
      'GET linked dispatch customers',
      'GET ignored dispatch customers',
      'GET unlinked dispatch customers',
      'GET unmerged dispatch customers',
      'GET dispatch customer to company possible matches',
      'GET company summaries',
      'GET company by ID',
      'GET company dispatch customer matches',
      'GET dispatch customer summaries',
      'GET dispatch customer aggregations',
    ],
    new: (args) => NewIgnoredDispatchCustomerFromWireFormat(args),
  },
  'PUT dispatch customers link': {
    method: 'PUT',
    urlSplits: ['/slab/dispatchcustomers/link'],
    invalidations: [
      'GET dispatch customers',
      'GET companies',
      'GET company by ID',
      'GET company dispatch customer matches',
      'GET linked dispatch customers',
      'GET ignored dispatch customers',
      'GET unlinked dispatch customers',
      'GET unmerged dispatch customers',
      'GET dispatch customer to company possible matches',
      'GET company summaries',
      'GET dispatch customer summaries',
      'GET dispatch customer aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET project companies by project ID',
    ],
    new: (args) => NewLinkDispatchCustomerToCompanyFromWireFormat(args),
  },
  'PUT dispatch customers merge': {
    method: 'PUT',
    urlSplits: ['/slab/dispatchcustomers/merge'],
    invalidations: [
      'GET dispatch customers',
      'GET companies',
      'GET company by ID',
      'GET company dispatch customer matches',
      'GET linked dispatch customers',
      'GET ignored dispatch customers',
      'GET unlinked dispatch customers',
      'GET unmerged dispatch customers',
      'GET dispatch customer to company possible matches',
      'GET company summaries',
      'GET dispatch customer summaries',
      'GET dispatch customer aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET project companies by project ID',
    ],
    new: (data) => data,
  },
  'PUT dispatch customers unlink': {
    method: 'PUT',
    urlSplits: ['/slab/dispatchcustomers/unlink/', 'id'],
    invalidations: [
      'GET dispatch customers',
      'GET linked dispatch customers',
      'GET ignored dispatch customers',
      'GET unlinked dispatch customers',
      'GET unmerged dispatch customers',
      'GET dispatch customer to company possible matches',
      'GET company by ID',
      'GET companies',
      'GET company summaries',
      'GET company dispatch customer matches',
      'GET dispatch customer summaries',
      'GET dispatch customer aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET project companies by project ID',
    ],
    new: (args) => NewLinkDispatchCustomerToCompanyFromWireFormat(args),
  },
  'PUT dispatch customers unmerge by ID': {
    method: 'PUT',
    urlSplits: ['/slab/dispatchcustomers/unmerge/', 'id'],
    invalidations: [
      'GET dispatch customers',
      'GET linked dispatch customers',
      'GET ignored dispatch customers',
      'GET unlinked dispatch customers',
      'GET unmerged dispatch customers',
      'GET dispatch customer to company possible matches',
      'GET company by ID',
      'GET companies',
      'GET company summaries',
      'GET company dispatch customer matches',
      'GET dispatch customer summaries',
      'GET dispatch customer aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET project companies by project ID',
    ],
    new: (args) => NewLinkDispatchCustomerToCompanyFromWireFormat(args),
  },
  'PUT division by ID': {
    method: 'PUT',
    urlSplits: ['/slab/divisions/', 'divisionID'],
    invalidations: ['GET divisions', 'GET markets'],
    new: (args) => NewDivisionFromWireFormat(args),
  },
  'PUT integration by ID as admin': {
    method: 'PUT',
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/integrations/', 'integrationID'],
    invalidations: ['GET integrations by tenant ID as admin'],
    new: (args) => NewIntegrationFromWireFormat(args),
  },
  'PUT market by ID': {
    method: 'PUT',
    urlSplits: ['/slab/markets/', 'marketID'],
    invalidations: [
      'GET markets',
      'GET market summaries',
      'GET user info',
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
      'GET divisions',
    ],
    new: (args) => NewMarketFromWireFormat(args),
  },
  'PUT material by ID': {
    method: 'PUT',
    urlSplits: ['/slab/materials/', 'id'],
    invalidations: [
      'GET materials',
      'GET material summaries',
      'GET material type aggregations',
      'GET materials by plant ID',
      'GET material by ID',
      'GET materials by mix ID',
      'GET mixes',
      'GET mix summaries',
      'GET mixes by plant ID',
      'GET mix by ID',
      'GET plant materials by plant ID',
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET plant products by plant ID',
      'GET project config products by project config ID',
      'GET project products by project ID',
      'GET quote products by quote ID',
    ],
    new: (args) => NewMaterialFromWireFormat(args),
  },
  'PUT mix by ID': {
    method: 'PUT',
    urlSplits: ['/slab/mixes/', 'id'],
    invalidations: [
      'GET mixes',
      'GET mix summaries',
      'GET mixes by plant ID',
      'GET mix by ID',
      'GET materials by mix ID',
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET plant products by plant ID',
      'GET project config products by project config ID',
      'GET project products by project ID',
      'GET quote products by quote ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
    ],
    new: (args) => NewMixFromWireFormat(args),
  },
  'PUT notification by ID': {
    method: 'PUT',
    urlSplits: ['/slab/notifications/', 'id'],
    invalidations: ['GET notifications', 'GET notification stats'],
    new: (args) => NewNotificationMessageFromWireFormat(args),
  },
  'PUT notification preferences': {
    method: 'PUT',
    urlSplits: ['/slab/notification-settings/preferences'],
    invalidations: ['GET user info', 'GET all notification settings'],
    new: (args) => NewNotificationSettingsFromWireFormat(args),
  },
  'PUT notification settings': {
    method: 'PUT',
    urlSplits: ['/slab/notification-settings/settings'],
    invalidations: ['GET all notification settings'],
    new: (args) => NewNotificationSettingsFromWireFormat(args),
  },
  'PUT pdf template by ID': {
    method: 'PUT',
    urlSplits: ['/slab/pdftemplates/', 'id'],
    invalidations: ['GET pdf templates'],
    new: (args) => NewPdfTemplateFromWireFormat(args),
  },
  'PUT planning budget by location ID and year ID': {
    method: 'PUT',
    urlSplits: ['/slab/planning/locations/', 'id', '/budget/', 'yearId'],
    invalidations: ['GET planning rollup by year ID'],
    // The route list test calls new({}) on every mutation, and a bare array has no {} form.
    new: (args) =>
      Array.isArray(args) ? args.map((a: any) => NewPlanningBudgetEntryFromWireFormat(a)) : [],
  },
  'PUT planning forecast by location ID and year ID': {
    method: 'PUT',
    urlSplits: ['/slab/planning/locations/', 'id', '/forecast/', 'yearId'],
    // Roll-ups show the budget, so a forecast edit leaves them standing.
    invalidations: [],
    new: (args) =>
      Array.isArray(args) ? args.map((a: any) => NewPlanningForecastEntryFromWireFormat(a)) : [],
  },
  'PUT plant by ID': {
    method: 'PUT',
    urlSplits: ['/slab/plants/', 'id'],
    invalidations: [
      'GET plants',
      'GET plants summaries',
      'GET plant by ID',
      'GET plant forecasts by plant ID',
      'GET plant materials by plant ID',
      'GET plant products by plant ID',
      'GET maps distance',
      'GET materials',
      'GET material summaries',
      'GET material type aggregations',
      'GET materials by plant ID',
      'GET material by ID',
      'GET mixes',
      'GET mix summaries',
      'GET mixes by plant ID',
      'GET mix by ID',
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET projects',
      'GET projects typeahead',
      'GET project configs',
      'GET project config summaries',
      'GET project config products by project config ID',
      'GET project config by ID',
      'GET project products by project ID',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project by ID',
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET quote products by quote ID',
      'GET quote configs',
      'GET quote configs summaries',
      'GET quote config by ID',
      'GET forecasts',
      'GET project forecast summaries',
      'GET forecast aggregations',
    ],
    new: (args) => NewPlantFromWireFormat(args),
  },
  'PUT product by ID': {
    method: 'PUT',
    urlSplits: ['/slab/products/', 'id'],
    invalidations: [
      'GET products',
      'GET products typeahead',
      'GET product summaries',
      'GET product category aggregations',
      'GET product by ID',
      'GET project config products by project config ID',
      'GET project products by project ID',
      'GET quote products by quote ID',
      'GET project quotes by project ID',
      'GET plant products by plant ID',
      'GET quote configs',
      'GET quote configs summaries',
      'GET quote config by ID',
      'GET user info',
    ],
    new: (args) => NewProductFromWireFormat(args),
  },
  'PUT project by ID': {
    method: 'PUT',
    urlSplits: ['/slab/projects/', 'id'],
    invalidations: [
      'GET projects',
      'GET projects typeahead',
      'GET project summaries',
      'GET project map pins',
      'GET project summaries by company ID',
      'GET project summaries by contact ID',
      'GET project by ID',
      'GET project products by project ID',
      'GET project companies by project ID',
      'GET project status aggregations',
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET project quotes by project ID',
      'GET maps distance',
      'GET project forecasts by project ID',
      'GET forecasts',
      'GET project forecast summaries',
      'GET forecast aggregations',
      'GET company summaries',
      'GET project companies by project ID',
      'GET reminder user setting summaries',
      'GET activity by ID',
    ],
    new: (args) => NewProjectFromWireFormat(args),
  },
  'PUT project config by ID': {
    method: 'PUT',
    urlSplits: ['/slab/projectconfigs/', 'id'],
    invalidations: [
      'GET project configs',
      'GET project config by ID',
      'GET project config products by project config ID',
      'GET project config summaries',
    ],
    new: (args) => NewProjectConfigFromWireFormat(args),
  },
  'PUT project loss reason by ID': {
    method: 'PUT',
    urlSplits: ['/slab/projectlossreasons/', 'id'],
    invalidations: ['GET project loss reasons'],
    new: (args) => NewProjectLossReasonFromWireFormat(args),
  },
  'PUT project status by ID': {
    method: 'PUT',
    urlSplits: ['/slab/projectstatuses/', 'id'],
    invalidations: ['GET project statuses', 'GET project status aggregations', 'GET projects'],
    new: (args) => NewProjectStatusFromWireFormat(args),
  },
  'PUT quote by ID': {
    method: 'PUT',
    urlSplits: ['/slab/quotes/', 'id'],
    invalidations: [
      'GET quotes',
      'GET quote price escalations',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET quote policy violations by quote ID',
      'GET quote products by quote ID',
      'GET project quotes by project ID',
      'GET reminder user setting summaries',
    ],
    new: (args) => NewQuoteFromWireFormat(args),
  },
  'PUT quote config by ID': {
    method: 'PUT',
    urlSplits: ['/slab/quoteconfigs/', 'id'],
    invalidations: ['GET quote configs', 'GET quote configs summaries', 'GET quote config by ID'],
    new: (args) => NewQuoteConfigFromWireFormat(args),
  },
  'PUT quote loss reason by ID': {
    method: 'PUT',
    urlSplits: ['/slab/quotelossreasons/', 'id'],
    invalidations: ['GET quote loss reasons'],
    new: (args) => NewQuoteLossReasonFromWireFormat(args),
  },
  'PUT quote policy': {
    method: 'PUT',
    urlSplits: ['/slab/quotepolicies/', 'policyID'],
    invalidations: ['GET quote policies'],
    new: (args) => NewQuoteFromWireFormat(args),
  },
  'PUT quote policy violation state by quote ID and violation ID': {
    method: 'PUT',
    urlSplits: ['/slab/quotes/', 'quoteID', '/policyviolations/', 'violationID', '/state'],
    invalidations: [
      'GET quotes',
      'GET quotes typeahead',
      'GET quote summaries',
      'GET quote status aggregations',
      'GET quote by ID',
      'GET quote pdf by quote ID and template ID',
      'GET quote pdf input json by quote ID',
      'GET quote policy violations by quote ID',
      'GET quote products by quote ID',
      'GET project quotes by project ID',
    ],
    new: (args) => NewQuoteFromWireFormat(args),
  },
  'PUT quote status by ID': {
    method: 'PUT',
    urlSplits: ['/slab/quotestatuses/', 'id'],
    invalidations: ['GET quote statuses', 'GET quote status aggregations', 'GET quotes'],
    new: (args) => NewQuoteStatusFromWireFormat(args),
  },
  'PUT reminder system setting by ID': {
    method: 'PUT',
    urlSplits: ['/slab/reminders/system-settings/', 'id'],
    invalidations: ['GET reminder system setting by ID', 'GET reminder system setting summaries'],

    new: (args) => NewReminderSystemSettingFromWireFormat(args),
  },
  'PUT reminder user setting by ID': {
    method: 'PUT',
    urlSplits: ['/slab/reminders/user-settings/', 'id'],
    invalidations: [
      'GET reminder user setting by ID',
      'GET reminder user setting summaries',
      'GET notification stats',
    ],
    new: (args) => NewReminderUserSettingFromWireFormat(args),
  },
  'PUT role by ID': {
    method: 'PUT',
    urlSplits: ['/slab/roles/', 'roleID'],
    invalidations: [
      'GET roles',
      'GET user info',
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewRoleFromWireFormat(args),
  },
  'PUT tenant settings': {
    method: 'PUT',
    urlSplits: ['/slab/tenants/settings'],
    invalidations: ['GET user info', 'GET tenants as admin', 'GET tenant margins overview'],
    new: (args) => NewUpdateTenantSettingsRequest(args),
  },
  'PUT user email defaults': {
    method: 'PUT',
    urlSplits: ['/slab/userinfo/email-defaults'],
    invalidations: ['GET user info'],
    new: (args) => NewUserEmailDefault(args),
  },
  'PUT tenant tier-pricing settings': {
    method: 'PUT',
    urlSplits: ['/slab/tenants/settings/tier-pricing'],
    invalidations: ['GET user info', 'GET tenants as admin'],
    new: (args) => NewTierPricingSettings(args),
  },
  'PUT tenant variance thresholds': {
    method: 'PUT',
    urlSplits: ['/slab/tenants/settings/variance-thresholds'],
    invalidations: ['GET tenant variance thresholds'],
    new: (args) => NewUpdateVarianceThresholdSettingsRequest(args),
  },
  'PUT tier pricing adjusted by ID': {
    method: 'PUT',
    urlSplits: ['/slab/tier-pricing/adjusted/', 'id'],
    invalidations: [
      'GET tier pricing adjusted',
      'GET tier pricing adjusted by ID',
      'GET tier pricing by company ID',
    ],
    new: (args) => NewAdjustedPricing(args),
  },
  'PUT tier pricing fixed by ID': {
    method: 'PUT',
    urlSplits: ['/slab/tier-pricing/fixed/', 'id'],
    invalidations: [
      'GET tier pricing fixed',
      'GET tier pricing by company ID',
      'GET tier pricing fixed by ID',
    ],
    new: (args) => NewFixedPricing(args),
  },
  'PUT trucking type by ID': {
    method: 'PUT',
    urlSplits: ['/slab/trucking-types/', 'id'],
    invalidations: [
      'GET trucking type by ID',
      'GET trucking type summaries',
      'GET trucking types typeahead',
      'GET project by ID',
      'GET quote products by quote ID',
      'GET project products by project ID',
    ],
    new: (args) => NewTruckingTypeFromWireFormat(args),
  },
  'PUT user by ID': {
    method: 'PUT',
    urlSplits: ['/slab/users/', 'userID'],
    invalidations: [
      'GET markets',
      'GET market summaries',
      'GET user info',
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewUserFromWireFormat(args),
  },
  'PUT user by ID as admin': {
    method: 'PUT',
    urlSplits: ['/slabadmin/tenants/', 'tenantID', '/users/', 'userID'],
    invalidations: [
      'GET markets',
      'GET market summaries',
      'GET user info',
      'GET user summaries',
      'GET users',
      'GET users by role ID',
      'GET users by tenant ID as admin',
    ],
    new: (args) => NewUserFromWireFormat(args),
  },
  'PUT user email signature by ID': {
    method: 'PUT',
    urlSplits: ['/slab/email-signatures/', 'id'],
    invalidations: ['GET users email signatures'],
    new: (args) => NewUserEmailSignatureFromWireFormat(args),
  },

  // ---- MOBILE-ONLY ROUTES — no web equivalent. ----
  'POST bulk-read-status notifications': {
    method: 'POST',
    urlSplits: ['/slab/notifications/bulk-read-status'],
    invalidations: ['GET notifications'],
    new: () => null,
  },
  'PUT user info settings': {
    method: 'PUT',
    urlSplits: ['/slab/userinfo/settings'],
    invalidations: ['GET user info'],
    new: (args) => NewUserSettingFromWireFormat(args),
  },
  'POST scan business card': {
    method: 'POST',
    urlSplits: ['/slab/contacts/scan-business-card'],
    invalidations: [],
    new: (args: any) => ({
      contact: NewContactFromWireFormat(args.contact),
      companyMatch: args.companyMatch
        ? {
            ...args.companyMatch,
            candidates: (args.companyMatch.candidates ?? []).map((c: any) => ({
              company: NewCompanyFromWireFormat(c.company),
              score: c.score,
            })),
          }
        : undefined,
      extractedAddress: args.extractedAddress
        ? NewAddressFromWireFormat(args.extractedAddress)
        : undefined,
    }),
  },
};
